import { IconButton, InputAdornment, SvgIcon } from '@mui/material';
import { FunctionComponent } from 'react';

import Icons from '@Constants/Icons.constants';

import StyledTextField from './TextField.styles';
import TextFieldProps from './TextField.types';

const TextField: FunctionComponent<TextFieldProps> = (
  props: TextFieldProps
): JSX.Element => {
  const { endIcon, endIconProps, disabled, ...resProps } = props;

  return (
    <StyledTextField
      disabled={disabled}
      InputProps={{
        endAdornment: endIcon && (
          <InputAdornment position="end" className="inputAdornment">
            <IconButton color="primary" disabled={disabled} {...endIconProps}>
              <SvgIcon>{Icons[endIcon]}</SvgIcon>
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...resProps}
    />
  );
};

TextField.defaultProps = {
  variant: 'outlined',
};

export default TextField;
